import { get, post } from "../http";
import baseURL from "../base";
//https://user.tsgyun.com/cases/list
export default {
    casesList (data) {
        // 列表
        return get(`${baseURL.userURL}cases/list`, data);
    },
    typeList (data) {
        // 类别
        return get(`${baseURL.userURL}type/list`, data);
    },
    casesReapply (data) {
        // 重新申请
        return post(`${baseURL.userURL}cases/reapply`, data);
    },
    typeAdd (data) {
        // 添加类别
        return get(`${baseURL.userURL}type/add`, data);
    },
    typeDel (data) {
        // 删除类别
        return post(`${baseURL.userURL}type/del`, data, {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token 123'
            },
            withCredentials: true
        });
    },
    casesMove (data) {
        // 移入类别
        return get(`${baseURL.userURL}cases/move`, data);
    },
    //cases/update 
    casesUpdate (data) {
        // 加入回收站
        return get(`${baseURL.userURL}cases/update`, data,
            {
                'Accept': '*/*',
                'Authorization': 'Token 123',
                'X-Requested-With': 'XMLHttpRequest',
            });
    },
};
